export default __webpack_public_path__ + "static/media/new2.9079898c.jpg";